module.exports = __webpack_public_path__ + "static/media/Betm.0b5ff008.otf";